import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.7607 18.33C24.5387 18.33 24.3551 18.1555 24.3551 17.9355C24.3551 17.7155 24.5311 17.5334 24.7607 17.5334C24.9826 17.5334 25.1586 17.7155 25.1586 17.9355C25.1586 18.1479 24.9826 18.33 24.7607 18.33Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1791 16.4259C24.1791 16.1983 24.3627 16.0162 24.5923 16.0162C24.8219 16.0162 25.0055 16.1983 25.0055 16.4259C25.0055 16.6535 24.8219 16.8355 24.5923 16.8355C24.3627 16.8355 24.1791 16.6535 24.1791 16.4259Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0797 14.5977C24.3016 14.5977 24.4776 14.7721 24.4776 14.9921C24.4776 15.2121 24.3016 15.3942 24.0797 15.3942C23.8578 15.3942 23.6818 15.2121 23.6818 14.9921C23.6818 14.7797 23.8578 14.5977 24.0797 14.5977Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2683 14.1501C23.0234 14.1501 22.8321 13.9529 22.8321 13.7177C22.8321 13.4749 23.0311 13.2853 23.2683 13.2853C23.5132 13.2853 23.7045 13.4825 23.7045 13.7177C23.7121 13.9529 23.5132 14.1501 23.2683 14.1501Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1896 12.2081C22.4344 12.2081 22.6258 12.4053 22.6258 12.6405C22.6258 12.8832 22.4268 13.0729 22.1896 13.0729C21.9447 13.0729 21.7534 12.8756 21.7534 12.6405C21.7534 12.4053 21.9447 12.2081 22.1896 12.2081Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8962 11.4192C21.1334 11.4192 21.3247 11.6088 21.3247 11.844C21.3247 12.0792 21.1334 12.2688 20.8962 12.2688C20.659 12.2688 20.4677 12.0792 20.4677 11.844C20.4753 11.6088 20.6666 11.4192 20.8962 11.4192Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4577 10.9715C19.6643 10.9715 19.825 11.1384 19.825 11.3356C19.825 11.5404 19.6567 11.6998 19.4577 11.6998C19.2511 11.6998 19.0904 11.5329 19.0904 11.3356C19.0904 11.1384 19.2511 10.9715 19.4577 10.9715Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2637 11.1688C18.2637 11.3433 18.1183 11.4874 17.9423 11.4874C17.7663 11.4874 17.6209 11.3433 17.6209 11.1688C17.6209 10.9944 17.7663 10.8502 17.9423 10.8502C18.1183 10.8502 18.2637 10.9944 18.2637 11.1688Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7179 11.3433C16.7179 11.5026 16.5879 11.6315 16.4272 11.6315C16.2665 11.6315 16.1364 11.5026 16.1364 11.3433C16.1364 11.184 16.2665 11.055 16.4272 11.055C16.5879 11.0474 16.7179 11.1764 16.7179 11.3433Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3025 11.8439C15.3025 12.0184 15.1571 12.1549 14.9888 12.1549C14.8128 12.1549 14.675 12.0108 14.675 11.8439C14.675 11.6694 14.8204 11.5329 14.9888 11.5329C15.1571 11.5253 15.3025 11.6694 15.3025 11.8439Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6879 12.2764C13.8945 12.2764 14.0552 12.4433 14.0552 12.6405C14.0552 12.8453 13.8869 13.0046 13.6879 13.0046C13.4813 13.0046 13.3206 12.8377 13.3206 12.6405C13.3206 12.4433 13.4889 12.2764 13.6879 12.2764Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6086 13.3611C12.8076 13.3611 12.9683 13.5205 12.9683 13.7177C12.9683 13.9149 12.8076 14.0742 12.6086 14.0742C12.4097 14.0742 12.249 13.9149 12.249 13.7177C12.249 13.5205 12.4097 13.3611 12.6086 13.3611Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7976 14.6356C11.9966 14.6356 12.1649 14.7949 12.1649 14.9997C12.1649 15.197 12.0042 15.3639 11.7976 15.3639C11.5987 15.3639 11.4303 15.2046 11.4303 14.9997C11.438 14.7949 11.5987 14.6356 11.7976 14.6356Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2926 16.039C11.5069 16.039 11.6829 16.2135 11.6829 16.4259C11.6829 16.6383 11.5069 16.8128 11.2926 16.8128C11.0784 16.8128 10.9024 16.6383 10.9024 16.4259C10.91 16.2135 11.0784 16.039 11.2926 16.039Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1241 17.5107C11.3536 17.5107 11.5449 17.7004 11.5449 17.928C11.5449 18.1556 11.3536 18.3452 11.1241 18.3452C10.8945 18.3452 10.7032 18.1556 10.7032 17.928C10.7032 17.7004 10.8945 17.5107 11.1241 17.5107Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8489 19.43C10.8489 19.1872 11.0479 18.9824 11.3004 18.9824C11.5453 18.9824 11.7519 19.1797 11.7519 19.43C11.7519 19.6728 11.5529 19.8776 11.3004 19.8776C11.0479 19.8776 10.8489 19.6803 10.8489 19.43Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7975 21.3189C11.545 21.3189 11.3384 21.1141 11.3384 20.8637C11.3384 20.6134 11.545 20.4086 11.7975 20.4086C12.0501 20.4086 12.2567 20.6134 12.2567 20.8637C12.2567 21.1141 12.0501 21.3189 11.7975 21.3189Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6087 21.6755C12.8689 21.6755 13.0832 21.8879 13.0832 22.1458C13.0832 22.4037 12.8689 22.6161 12.6087 22.6161C12.3485 22.6161 12.1343 22.4037 12.1343 22.1458C12.1343 21.8803 12.3485 21.6755 12.6087 21.6755Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6879 22.692C13.9787 22.692 14.2159 22.9272 14.2159 23.2155C14.2159 23.5037 13.9787 23.7389 13.6879 23.7389C13.3971 23.7389 13.1599 23.5037 13.1599 23.2155C13.1676 22.9272 13.3971 22.692 13.6879 22.692Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9811 23.4961C15.2719 23.4961 15.5091 23.7313 15.5091 24.0195C15.5091 24.3078 15.2719 24.543 14.9811 24.543C14.6903 24.543 14.4531 24.3078 14.4531 24.0195C14.4608 23.7313 14.6903 23.4961 14.9811 23.4961Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4273 25.0588C16.1212 25.0588 15.8763 24.816 15.8763 24.5126C15.8763 24.2091 16.1212 23.9664 16.4273 23.9664C16.7334 23.9664 16.9783 24.2091 16.9783 24.5126C16.9706 24.816 16.7257 25.0588 16.4273 25.0588Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.384 24.6871C17.384 24.3837 17.6365 24.1334 17.9426 24.1334C18.2487 24.1334 18.5012 24.3837 18.5012 24.6871C18.5012 24.9906 18.2487 25.2409 17.9426 25.2409C17.6289 25.2409 17.384 24.9906 17.384 24.6871Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9066 24.5202C18.9066 24.2168 19.1515 23.974 19.4576 23.974C19.7636 23.974 20.0085 24.2168 20.0085 24.5202C20.0085 24.8236 19.7636 25.0664 19.4576 25.0664C19.1515 25.0588 18.9066 24.816 18.9066 24.5202Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8963 24.543C20.6055 24.543 20.3683 24.3078 20.3683 24.0195C20.3683 23.7313 20.6055 23.4961 20.8963 23.4961C21.1871 23.4961 21.4243 23.7313 21.4243 24.0195C21.4243 24.3078 21.1871 24.543 20.8963 24.543Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1896 23.6478C21.9447 23.6478 21.7534 23.4506 21.7534 23.2154C21.7534 22.9727 21.9524 22.783 22.1896 22.783C22.4344 22.783 22.6258 22.9803 22.6258 23.2154C22.6334 23.4506 22.4344 23.6478 22.1896 23.6478Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2683 22.5327C23.0541 22.5327 22.8781 22.3582 22.8781 22.1458C22.8781 21.9334 23.0541 21.7589 23.2683 21.7589C23.4826 21.7589 23.6586 21.9334 23.6586 22.1458C23.6662 22.3582 23.4902 22.5327 23.2683 22.5327Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0795 20.5072C24.2785 20.5072 24.4392 20.6665 24.4392 20.8637C24.4392 21.061 24.2785 21.2203 24.0795 21.2203C23.8806 21.2203 23.7199 21.061 23.7199 20.8637C23.7199 20.6665 23.8882 20.5072 24.0795 20.5072Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5847 19.8093C24.3781 19.8093 24.2097 19.6424 24.2097 19.4376C24.2097 19.2327 24.3781 19.0659 24.5847 19.0659C24.7913 19.0659 24.9597 19.2327 24.9597 19.4376C24.9673 19.6424 24.799 19.8093 24.5847 19.8093Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4593 18.3073C26.2527 18.3073 26.0843 18.1404 26.0843 17.9356C26.0843 17.7307 26.2527 17.5638 26.4593 17.5638C26.6659 17.5638 26.8342 17.7307 26.8342 17.9356C26.8419 18.1328 26.6735 18.3073 26.4593 18.3073Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3217 16.0239C26.5437 16.0239 26.7197 16.1983 26.7197 16.4259C26.7197 16.6459 26.5437 16.8204 26.3217 16.8204C26.0998 16.8204 25.9162 16.6459 25.9162 16.4259C25.9238 16.1983 26.0998 16.0239 26.3217 16.0239Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4876 14.9618C25.4876 14.7267 25.6789 14.5294 25.9238 14.5294C26.161 14.5294 26.36 14.7191 26.36 14.9618C26.36 15.197 26.1687 15.3942 25.9238 15.3942C25.6789 15.3942 25.4876 15.197 25.4876 14.9618Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.2579 14.0591C24.9977 14.0591 24.7911 13.8543 24.7911 13.5964C24.7911 13.3384 24.9977 13.1336 25.2579 13.1336C25.5181 13.1336 25.7247 13.3384 25.7247 13.5964C25.7247 13.8543 25.5104 14.0591 25.2579 14.0591Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8884 12.3674C23.8884 12.1095 24.095 11.9047 24.3552 11.9047C24.6154 11.9047 24.822 12.1095 24.822 12.3674C24.822 12.6253 24.6154 12.8302 24.3552 12.8302C24.1027 12.8377 23.8884 12.6253 23.8884 12.3674Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2529 11.7833C23.0004 11.7833 22.7861 11.5785 22.7861 11.3205C22.7861 11.0702 22.9928 10.8578 23.2529 10.8578C23.5055 10.8578 23.7197 11.0626 23.7197 11.3205C23.7197 11.5785 23.5131 11.7833 23.2529 11.7833Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5389 10.4936C21.5389 10.2509 21.7379 10.0612 21.9751 10.0612C22.22 10.0612 22.4113 10.2585 22.4113 10.4936C22.4113 10.7364 22.2123 10.926 21.9751 10.926C21.7379 10.926 21.5389 10.7288 21.5389 10.4936Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5749 9.46191C20.8198 9.46191 21.0111 9.65915 21.0111 9.89432C21.0111 10.1371 20.8121 10.3267 20.5749 10.3267C20.33 10.3267 20.1387 10.1295 20.1387 9.89432C20.1311 9.65156 20.33 9.46191 20.5749 9.46191Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.473 9.56059C19.473 9.773 19.297 9.94748 19.0827 9.94748C18.8685 9.94748 18.6925 9.773 18.6925 9.56059C18.6925 9.34818 18.8685 9.1737 19.0827 9.1737C19.3047 9.16611 19.473 9.34059 19.473 9.56059Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8736 9.49224C17.8736 9.65913 17.7359 9.80327 17.5599 9.80327C17.3915 9.80327 17.2461 9.66672 17.2461 9.49224C17.2461 9.32535 17.3839 9.18121 17.5599 9.18121C17.7282 9.18121 17.8736 9.31776 17.8736 9.49224Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3201 9.68954C16.3201 9.84126 16.1976 9.96264 16.0446 9.96264C15.8915 9.96264 15.7691 9.84126 15.7691 9.68954C15.7691 9.53782 15.8915 9.41644 16.0446 9.41644C16.1976 9.41644 16.3201 9.53782 16.3201 9.68954Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8431 10.1599C14.8431 10.2964 14.7283 10.4102 14.5906 10.4102C14.4528 10.4102 14.338 10.2964 14.338 10.1599C14.338 10.0233 14.4528 9.90955 14.5906 9.90955C14.7283 9.90955 14.8431 10.0233 14.8431 10.1599Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5349 10.8805C13.5349 11.0398 13.4048 11.1688 13.2441 11.1688C13.0834 11.1688 12.9533 11.0398 12.9533 10.8805C12.9533 10.7212 13.0834 10.5922 13.2441 10.5922C13.4048 10.5922 13.5349 10.7212 13.5349 10.8805Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0503 11.5405C12.211 11.5405 12.3411 11.6694 12.3411 11.8287C12.3411 11.988 12.211 12.117 12.0503 12.117C11.8896 12.117 11.7595 11.988 11.7595 11.8287C11.7671 11.6618 11.8896 11.5405 12.0503 11.5405Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3539 12.9666C11.3539 13.1335 11.2161 13.2701 11.0478 13.2701C10.8794 13.2701 10.7417 13.1335 10.7417 12.9666C10.7417 12.7998 10.8794 12.6632 11.0478 12.6632C11.2161 12.6556 11.3539 12.7922 11.3539 12.9666Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2597 13.8998C10.4587 13.8998 10.627 14.0591 10.627 14.2639C10.627 14.4611 10.4663 14.628 10.2597 14.628C10.0607 14.628 9.89239 14.4687 9.89239 14.2639C9.90004 14.0667 10.0607 13.8998 10.2597 13.8998Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.36405 15.6825C9.36405 15.4853 9.52475 15.3184 9.73136 15.3184C9.93797 15.3184 10.0987 15.4777 10.0987 15.6825C10.0987 15.8797 9.93797 16.0466 9.73136 16.0466C9.52475 16.0466 9.36405 15.8797 9.36405 15.6825Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.45598 16.8128C9.65494 16.8128 9.82329 16.9721 9.82329 17.1769C9.82329 17.3742 9.66259 17.5411 9.45598 17.5411C9.25702 17.5411 9.08867 17.3818 9.08867 17.1769C9.08867 16.9721 9.24937 16.8128 9.45598 16.8128Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.45602 18.2996C9.67028 18.2996 9.84628 18.4741 9.84628 18.6865C9.84628 18.8989 9.67028 19.0734 9.45602 19.0734C9.24175 19.0734 9.06575 18.8989 9.06575 18.6865C9.0581 18.4741 9.2341 18.2996 9.45602 18.2996Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.30315 20.1735C9.30315 19.9459 9.49446 19.7562 9.72403 19.7562C9.9536 19.7562 10.1449 19.9459 10.1449 20.1735C10.1449 20.401 9.9536 20.5907 9.72403 20.5907C9.49446 20.5907 9.30315 20.4086 9.30315 20.1735Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2596 22.0472C10.0071 22.0472 9.80047 21.8423 9.80047 21.592C9.80047 21.3417 10.0071 21.1368 10.2596 21.1368C10.5121 21.1368 10.7187 21.3417 10.7187 21.592C10.7187 21.8423 10.5198 22.0472 10.2596 22.0472Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5299 22.8968C11.5299 23.1623 11.3156 23.3823 11.0401 23.3823C10.7723 23.3823 10.5504 23.1699 10.5504 22.8968C10.5504 22.6313 10.7646 22.4113 11.0401 22.4113C11.3156 22.4113 11.5299 22.6313 11.5299 22.8968Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0503 23.5264C12.3334 23.5264 12.563 23.754 12.563 24.0347C12.563 24.3154 12.3334 24.543 12.0503 24.543C11.7671 24.543 11.5376 24.3154 11.5376 24.0347C11.5376 23.754 11.7671 23.5264 12.0503 23.5264Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.244 24.4519C13.5348 24.4519 13.772 24.6871 13.772 24.9753C13.772 25.2636 13.5348 25.4988 13.244 25.4988C12.9533 25.4988 12.716 25.2636 12.716 24.9753C12.716 24.6871 12.9533 24.4519 13.244 24.4519Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1265 25.6961C15.1265 25.9919 14.8893 26.2271 14.5908 26.2271C14.2924 26.2271 14.0552 25.9919 14.0552 25.6961C14.0552 25.4002 14.2924 25.165 14.5908 25.165C14.8893 25.165 15.1265 25.4002 15.1265 25.6961Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0446 26.7429C15.7233 26.7429 15.4631 26.485 15.4631 26.1664C15.4631 25.8478 15.7233 25.5898 16.0446 25.5898C16.366 25.5898 16.6262 25.8478 16.6262 26.1664C16.6262 26.485 16.366 26.7429 16.0446 26.7429Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5598 26.9325C17.246 26.9325 16.9935 26.6822 16.9935 26.3712C16.9935 26.0602 17.246 25.8098 17.5598 25.8098C17.8735 25.8098 18.126 26.0602 18.126 26.3712C18.126 26.6822 17.8735 26.9325 17.5598 26.9325Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0828 26.8567C18.769 26.8567 18.5165 26.6064 18.5165 26.2954C18.5165 25.9843 18.769 25.7416 19.0828 25.7416C19.3965 25.7416 19.649 25.9919 19.649 26.2954C19.649 26.6064 19.3965 26.8567 19.0828 26.8567Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.575 26.4698C20.2918 26.4698 20.0623 26.2423 20.0623 25.9616C20.0623 25.6809 20.2918 25.4533 20.575 25.4533C20.8581 25.4533 21.0877 25.6809 21.0877 25.9616C21.0877 26.2423 20.8581 26.4698 20.575 26.4698Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4702 25.3699C21.4702 25.0968 21.6997 24.8692 21.9752 24.8692C22.2584 24.8692 22.4803 25.0968 22.4803 25.3699C22.4803 25.6506 22.2507 25.8706 21.9752 25.8706C21.6997 25.8706 21.4702 25.643 21.4702 25.3699Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.253 24.9678C23.0157 24.9678 22.8168 24.7781 22.8168 24.5354C22.8168 24.3002 23.0081 24.103 23.253 24.103C23.4902 24.103 23.6891 24.2926 23.6891 24.5354C23.6891 24.7705 23.4902 24.9678 23.253 24.9678Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3549 23.8299C24.1636 23.8299 24.0106 23.6782 24.0106 23.4885C24.0106 23.2989 24.1636 23.1472 24.3549 23.1472C24.5462 23.1472 24.6993 23.2989 24.6993 23.4885C24.6993 23.6782 24.5462 23.8299 24.3549 23.8299Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.258 22.6161C25.0591 22.6161 24.8984 22.4568 24.8984 22.2596C24.8984 22.0623 25.0591 21.903 25.258 21.903C25.457 21.903 25.6177 22.0623 25.6177 22.2596C25.6177 22.4568 25.457 22.6161 25.258 22.6161Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5795 20.8941C25.5795 20.7044 25.7326 20.5603 25.9162 20.5603C26.1075 20.5603 26.2529 20.712 26.2529 20.8941C26.2529 21.0837 26.0999 21.2279 25.9162 21.2279C25.7326 21.2355 25.5795 21.0837 25.5795 20.8941Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9468 19.4376C25.9468 19.2327 26.1152 19.0659 26.3218 19.0659C26.5284 19.0659 26.6967 19.2327 26.6967 19.4376C26.6967 19.6424 26.5284 19.8093 26.3218 19.8093C26.1152 19.8093 25.9468 19.6424 25.9468 19.4376Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7448 17.928C27.7448 17.7004 27.9361 17.5107 28.1657 17.5107C28.3952 17.5107 28.5865 17.7004 28.5865 17.928C28.5865 18.1556 28.3952 18.3452 28.1657 18.3452C27.9361 18.3452 27.7448 18.1631 27.7448 17.928Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0509 15.9708C28.3035 15.9708 28.5024 16.1756 28.5024 16.4183C28.5024 16.6687 28.2958 16.8659 28.0509 16.8659C27.7984 16.8659 27.5994 16.6611 27.5994 16.4183C27.5994 16.168 27.7984 15.9708 28.0509 15.9708Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2322 14.9391C27.2322 14.6736 27.4464 14.4612 27.7142 14.4612C27.9821 14.4612 28.1963 14.6736 28.1963 14.9391C28.1963 15.2046 27.9821 15.417 27.7142 15.417C27.4464 15.417 27.2322 15.2046 27.2322 14.9391Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.1557 13.9907C26.9031 13.9907 26.6889 13.7859 26.6889 13.528C26.6889 13.2777 26.8955 13.0652 27.1557 13.0652C27.4082 13.0652 27.6224 13.2701 27.6224 13.528C27.6148 13.7859 27.4082 13.9907 27.1557 13.9907Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3904 12.7543C26.0919 12.7543 25.8471 12.5115 25.8471 12.2157C25.8471 11.9198 26.0919 11.6771 26.3904 11.6771C26.6888 11.6771 26.9337 11.9198 26.9337 12.2157C26.9337 12.5191 26.6888 12.7543 26.3904 12.7543Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4339 11.5102C25.1661 11.5102 24.9518 11.2978 24.9518 11.0322C24.9518 10.7667 25.1661 10.5543 25.4339 10.5543C25.7017 10.5543 25.916 10.7667 25.916 11.0322C25.916 11.2978 25.7017 11.5102 25.4339 11.5102Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3167 9.48468C24.6074 9.48468 24.8447 9.71985 24.8447 10.0081C24.8447 10.2964 24.6074 10.5316 24.3167 10.5316C24.0259 10.5316 23.7886 10.2964 23.7886 10.0081C23.7886 9.71985 24.0259 9.48468 24.3167 9.48468Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.054 9.62885C22.7861 9.62885 22.5642 9.41644 22.5642 9.14334C22.5642 8.87783 22.7861 8.65784 23.054 8.65784C23.3218 8.65784 23.5437 8.87025 23.5437 9.14334C23.5437 9.41644 23.3218 9.62885 23.054 9.62885Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1437 8.49095C22.1437 8.74887 21.9371 8.95369 21.6769 8.95369C21.4167 8.95369 21.2101 8.74887 21.2101 8.49095C21.2101 8.23302 21.4167 8.0282 21.6769 8.0282C21.9371 8.0282 22.1437 8.23302 22.1437 8.49095Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6283 8.04337C20.6283 8.27095 20.4446 8.45302 20.2151 8.45302C19.9855 8.45302 19.8018 8.27095 19.8018 8.04337C19.8018 7.81579 19.9855 7.63373 20.2151 7.63373C20.4446 7.64131 20.6283 7.82338 20.6283 8.04337Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1131 7.82334C19.1131 8.05092 18.9295 8.23299 18.6999 8.23299C18.4704 8.23299 18.2867 8.05092 18.2867 7.82334C18.2867 7.59576 18.4704 7.4137 18.6999 7.4137C18.9295 7.4137 19.1131 7.59576 19.1131 7.82334Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1772 7.47437C17.3685 7.47437 17.5216 7.62609 17.5216 7.81574C17.5216 8.00539 17.3685 8.15711 17.1772 8.15711C16.9859 8.15711 16.8328 8.00539 16.8328 7.81574C16.8328 7.63367 16.9859 7.47437 17.1772 7.47437Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9453 8.04336C15.9453 8.19508 15.8228 8.31646 15.6698 8.31646C15.5168 8.31646 15.3943 8.19508 15.3943 8.04336C15.3943 7.89164 15.5168 7.77026 15.6698 7.77026C15.8228 7.77026 15.9453 7.89164 15.9453 8.04336Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9786 8.49095C13.9786 8.36957 14.0781 8.26337 14.2081 8.26337C14.3306 8.26337 14.4377 8.36198 14.4377 8.49095C14.4377 8.61232 14.3382 8.71853 14.2081 8.71853C14.0781 8.71853 13.9786 8.61991 13.9786 8.49095Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0985 9.15089C13.0985 9.29502 12.976 9.4164 12.8307 9.4164C12.6853 9.4164 12.5628 9.29502 12.5628 9.15089C12.5628 9.00675 12.6853 8.88538 12.8307 8.88538C12.976 8.88538 13.0985 8.99917 13.0985 9.15089Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5681 10.2509C11.4304 10.2509 11.3156 10.1371 11.3156 10.0005C11.3156 9.86397 11.4304 9.75018 11.5681 9.75018C11.7059 9.75018 11.8206 9.86397 11.8206 10.0005C11.813 10.1371 11.7059 10.2509 11.5681 10.2509Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.734 11.0323C10.734 11.1916 10.6039 11.3206 10.4432 11.3206C10.2825 11.3206 10.1525 11.1916 10.1525 11.0323C10.1525 10.873 10.2825 10.744 10.4432 10.744C10.6039 10.7516 10.734 10.873 10.734 11.0323Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.76221 12.2156C9.76221 12.3598 9.63978 12.4812 9.49438 12.4812C9.34899 12.4812 9.22655 12.3598 9.22655 12.2156C9.22655 12.0715 9.34899 11.9501 9.49438 11.9501C9.63978 11.9501 9.76221 12.0715 9.76221 12.2156Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.72913 13.2322C8.88982 13.2322 9.02756 13.3612 9.02756 13.5281C9.02756 13.6874 8.89748 13.8239 8.72913 13.8239C8.56843 13.8239 8.43069 13.695 8.43069 13.5281C8.43069 13.3688 8.56078 13.2322 8.72913 13.2322Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.84145 14.9391C7.84145 14.757 7.98685 14.6129 8.1705 14.6129C8.3465 14.6129 8.49955 14.757 8.49955 14.9391C8.49955 15.1211 8.35416 15.2653 8.1705 15.2653C7.98685 15.2653 7.84145 15.1211 7.84145 14.9391Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.826 16.0921C8.00965 16.0921 8.15504 16.2362 8.15504 16.4183C8.15504 16.5928 8.00965 16.7445 7.826 16.7445C7.64234 16.7445 7.49695 16.6004 7.49695 16.4183C7.5046 16.2362 7.64999 16.0921 7.826 16.0921Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.71123 18.3149C7.49696 18.3149 7.32096 18.1404 7.32096 17.928C7.32096 17.7156 7.49696 17.5411 7.71123 17.5411C7.92549 17.5411 8.10149 17.7156 8.10149 17.928C8.10914 18.1404 7.93314 18.3149 7.71123 18.3149Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.82632 19.832C7.61205 19.832 7.43605 19.6575 7.43605 19.4451C7.43605 19.2327 7.61205 19.0582 7.82632 19.0582C8.04058 19.0582 8.21658 19.2327 8.21658 19.4451C8.22423 19.6575 8.04823 19.832 7.82632 19.832Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.76485 20.9169C7.76485 20.6969 7.94086 20.5224 8.16277 20.5224C8.38469 20.5224 8.56069 20.6969 8.56069 20.9169C8.56069 21.1369 8.38469 21.3113 8.16277 21.3113C7.94851 21.3189 7.76485 21.1369 7.76485 20.9169Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16517 22.3279C9.16517 22.563 8.97387 22.7603 8.729 22.7603C8.49178 22.7603 8.29282 22.5706 8.29282 22.3279C8.29282 22.0927 8.48412 21.8954 8.729 21.8954C8.96622 21.8954 9.16517 22.0927 9.16517 22.3279Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.94568 23.6403C9.94568 23.8906 9.73907 24.0878 9.4942 24.0878C9.24168 24.0878 9.04272 23.883 9.04272 23.6403C9.04272 23.3899 9.24933 23.1927 9.4942 23.1927C9.73907 23.1927 9.94568 23.3899 9.94568 23.6403Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.443 24.3306C10.7185 24.3306 10.9404 24.5506 10.9404 24.8237C10.9404 25.0968 10.7185 25.3168 10.443 25.3168C10.1675 25.3168 9.93797 25.0968 9.93797 24.8237C9.93797 24.5506 10.1675 24.3306 10.443 24.3306Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1115 25.8553C12.1115 26.1588 11.8666 26.4015 11.5606 26.4015C11.2545 26.4015 11.0096 26.1588 11.0096 25.8553C11.0096 25.5519 11.2545 25.3091 11.5606 25.3091C11.8666 25.3091 12.1115 25.5519 12.1115 25.8553Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8308 26.1588C13.1368 26.1588 13.3894 26.4091 13.3894 26.7125C13.3894 27.016 13.1368 27.2663 12.8308 27.2663C12.5247 27.2663 12.2721 27.016 12.2721 26.7125C12.2721 26.4015 12.517 26.1588 12.8308 26.1588Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.208 27.934C13.8943 27.934 13.6341 27.6836 13.6341 27.365C13.6341 27.054 13.8866 26.7961 14.208 26.7961C14.5217 26.7961 14.7819 27.0464 14.7819 27.365C14.7743 27.6761 14.5217 27.934 14.208 27.934Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.662 28.4042C15.333 28.4042 15.0651 28.1387 15.0651 27.8125C15.0651 27.4863 15.333 27.2208 15.662 27.2208C15.9911 27.2208 16.2589 27.4863 16.2589 27.8125C16.2589 28.1387 15.9911 28.4042 15.662 28.4042Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1774 28.6015C16.8636 28.6015 16.6034 28.3512 16.6034 28.0326C16.6034 27.714 16.856 27.4636 17.1774 27.4636C17.4911 27.4636 17.7513 27.714 17.7513 28.0326C17.7513 28.3512 17.4911 28.6015 17.1774 28.6015Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7075 28.5636C18.4167 28.5636 18.1795 28.3284 18.1795 28.0402C18.1795 27.7519 18.4167 27.5167 18.7075 27.5167C18.9983 27.5167 19.2355 27.7519 19.2355 28.0402C19.2355 28.3284 18.9983 28.5636 18.7075 28.5636Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2151 28.3359C19.9244 28.3359 19.6871 28.1008 19.6871 27.8125C19.6871 27.5242 19.9244 27.2891 20.2151 27.2891C20.5059 27.2891 20.7431 27.5242 20.7431 27.8125C20.7431 28.1008 20.5059 28.3359 20.2151 28.3359Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6769 27.8733C21.3937 27.8733 21.1642 27.6457 21.1642 27.365C21.1642 27.0843 21.3937 26.8568 21.6769 26.8568C21.96 26.8568 22.1896 27.0843 22.1896 27.365C22.1896 27.6457 21.96 27.8733 21.6769 27.8733Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.054 27.1146C22.8245 27.1146 22.6408 26.9326 22.6408 26.705C22.6408 26.4774 22.8245 26.2953 23.054 26.2953C23.2836 26.2953 23.4673 26.4774 23.4673 26.705C23.4673 26.9326 23.2836 27.1146 23.054 27.1146Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3168 26.1967C24.1255 26.1967 23.9725 26.045 23.9725 25.8553C23.9725 25.6657 24.1255 25.514 24.3168 25.514C24.5081 25.514 24.6612 25.6657 24.6612 25.8553C24.6612 26.045 24.5081 26.1967 24.3168 26.1967Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4338 25.2029C25.2195 25.2029 25.0512 25.036 25.0512 24.8236C25.0512 24.6112 25.2195 24.4443 25.4338 24.4443C25.6481 24.4443 25.8164 24.6112 25.8164 24.8236C25.8164 25.036 25.6481 25.2029 25.4338 25.2029Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.7196 23.6402C26.7196 23.8223 26.5742 23.9664 26.3906 23.9664C26.2069 23.9664 26.0615 23.8223 26.0615 23.6402C26.0615 23.4582 26.2069 23.314 26.3906 23.314C26.5742 23.314 26.7196 23.4582 26.7196 23.6402Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8114 22.3278C26.8114 22.1382 26.9645 21.9865 27.1481 21.9865C27.3394 21.9865 27.4848 22.1382 27.4848 22.3278C27.4848 22.5175 27.3318 22.6616 27.1481 22.6616C26.9645 22.6616 26.8114 22.5175 26.8114 22.3278Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7142 21.2809C27.5152 21.2809 27.3469 21.1216 27.3469 20.9168C27.3469 20.7196 27.5076 20.5527 27.7142 20.5527C27.9131 20.5527 28.0815 20.712 28.0815 20.9168C28.0738 21.114 27.9131 21.2809 27.7142 21.2809Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0512 19.832C27.8293 19.832 27.6533 19.6576 27.6533 19.4376C27.6533 19.2176 27.8293 19.0431 28.0512 19.0431C28.2731 19.0431 28.4491 19.2176 28.4491 19.4376C28.4491 19.6576 28.2731 19.832 28.0512 19.832Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3249 5.73724C18.5315 5.73724 18.6999 5.90414 18.6999 6.10896C18.6999 6.31378 18.5315 6.48067 18.3249 6.48067C18.1183 6.48067 17.9499 6.31378 17.9499 6.10896C17.9423 5.90414 18.1106 5.73724 18.3249 5.73724Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7947 5.88892C16.9401 5.88892 17.0625 6.01029 17.0625 6.15443C17.0625 6.29856 16.9401 6.41994 16.7947 6.41994C16.6493 6.41994 16.5268 6.29856 16.5268 6.15443C16.5268 6.01029 16.6493 5.88892 16.7947 5.88892Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3804 9.20398C25.0896 9.20398 24.8524 8.96881 24.8524 8.68054C24.8524 8.39227 25.0896 8.1571 25.3804 8.1571C25.6712 8.1571 25.9084 8.39227 25.9084 8.68054C25.9008 8.96881 25.6712 9.20398 25.3804 9.20398Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5973 7.81573C23.5973 7.52746 23.8346 7.2923 24.1253 7.2923C24.4161 7.2923 24.6533 7.52746 24.6533 7.81573C24.6533 8.104 24.4161 8.33917 24.1253 8.33917C23.8346 8.33917 23.5973 8.104 23.5973 7.81573Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.771 7.66404C22.465 7.66404 22.2201 7.42129 22.2201 7.11785C22.2201 6.81441 22.465 6.57166 22.771 6.57166C23.0771 6.57166 23.322 6.81441 23.322 7.11785C23.322 7.4137 23.0771 7.66404 22.771 7.66404Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3324 6.11652C21.6002 6.11652 21.8145 6.32892 21.8145 6.59444C21.8145 6.85995 21.6002 7.07236 21.3324 7.07236C21.0646 7.07236 20.8503 6.85995 20.8503 6.59444C20.8503 6.32892 21.0722 6.11652 21.3324 6.11652Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8479 5.80548C20.0928 5.80548 20.2994 6.00272 20.2994 6.25306C20.2994 6.49581 20.1005 6.70063 19.8479 6.70063C19.6031 6.70063 19.3964 6.5034 19.3964 6.25306C19.3964 6.0103 19.5954 5.80548 19.8479 5.80548Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.287 6.13171C15.4324 6.13171 15.5548 6.25309 15.5548 6.39723C15.5548 6.54136 15.4324 6.66274 15.287 6.66274C15.1416 6.66274 15.0192 6.54136 15.0192 6.39723C15.0192 6.25309 15.134 6.13171 15.287 6.13171Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8179 6.60956C13.9403 6.60956 14.0398 6.70818 14.0398 6.82955C14.0398 6.95093 13.9403 7.04955 13.8179 7.04955C13.6955 7.04955 13.596 6.95093 13.596 6.82955C13.596 6.70818 13.6955 6.60956 13.8179 6.60956Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4253 7.23926C12.5401 7.23926 12.6319 7.33029 12.6319 7.44408C12.6319 7.55787 12.5401 7.6489 12.4253 7.6489C12.3105 7.6489 12.2187 7.55787 12.2187 7.44408C12.2187 7.33029 12.3105 7.23926 12.4253 7.23926Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1164 8.00543C11.2389 8.00543 11.3383 8.10405 11.3383 8.22543C11.3383 8.3468 11.2389 8.44542 11.1164 8.44542C10.994 8.44542 10.8945 8.3468 10.8945 8.22543C10.8945 8.10405 10.994 8.00543 11.1164 8.00543Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1602 9.1737C10.1602 9.30267 10.0531 9.40887 9.92298 9.40887C9.79289 9.40887 9.68576 9.30267 9.68576 9.1737C9.68576 9.04474 9.79289 8.93854 9.92298 8.93854C10.0531 8.93854 10.1602 9.04474 10.1602 9.1737Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.09643 10.2661C9.09643 10.395 8.9893 10.5012 8.85921 10.5012C8.72913 10.5012 8.62199 10.395 8.62199 10.2661C8.62199 10.1371 8.72913 10.0309 8.85921 10.0309C8.9893 10.0309 9.09643 10.1295 9.09643 10.2661Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.2086 11.4798C8.2086 11.6239 8.08616 11.7453 7.94077 11.7453C7.79538 11.7453 7.67294 11.6239 7.67294 11.4798C7.67294 11.3356 7.79538 11.2143 7.94077 11.2143C8.09382 11.2067 8.2086 11.3281 8.2086 11.4798Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.48182 12.7997C7.48182 12.959 7.35173 13.088 7.19103 13.088C7.03033 13.088 6.90025 12.959 6.90025 12.7997C6.90025 12.6404 7.03033 12.5115 7.19103 12.5115C7.35173 12.5115 7.48182 12.6404 7.48182 12.7997Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.90788 14.2032C6.90788 14.3625 6.77779 14.4915 6.6171 14.4915C6.4564 14.4915 6.32631 14.3625 6.32631 14.2032C6.32631 14.0439 6.4564 13.9149 6.6171 13.9149C6.77779 13.9149 6.90788 14.0439 6.90788 14.2032Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.22681 15.3563C6.40281 15.3563 6.54055 15.4928 6.54055 15.6673C6.54055 15.8418 6.40281 15.9783 6.22681 15.9783C6.05846 15.9783 5.91306 15.8418 5.91306 15.6673C5.92072 15.5004 6.05846 15.3563 6.22681 15.3563Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.03549 16.8583C6.21149 16.8583 6.34923 16.9948 6.34923 17.1693C6.34923 17.3438 6.21149 17.4803 6.03549 17.4803C5.86714 17.4803 5.72175 17.3438 5.72175 17.1693C5.72175 17.0024 5.85949 16.8583 6.03549 16.8583Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.03567 18.3528C6.22697 18.3528 6.37237 18.5045 6.37237 18.6866C6.37237 18.8686 6.21932 19.0204 6.03567 19.0204C5.84436 19.0204 5.69897 18.8686 5.69897 18.6866C5.69897 18.5045 5.84436 18.3528 6.03567 18.3528Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.88242 20.1886C5.88242 19.999 6.03547 19.8397 6.23443 19.8397C6.43339 19.8397 6.58643 19.9914 6.58643 20.1886C6.58643 20.3783 6.43339 20.5376 6.23443 20.5376C6.03547 20.5376 5.88242 20.3783 5.88242 20.1886Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.6172 22.0244C6.41059 22.0244 6.24224 21.8575 6.24224 21.6527C6.24224 21.4479 6.41059 21.281 6.6172 21.281C6.82381 21.281 6.99216 21.4479 6.99216 21.6527C6.99216 21.8575 6.82381 22.0244 6.6172 22.0244Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.61941 23.0637C7.61941 23.2988 7.42811 23.4885 7.19089 23.4885C6.95367 23.4885 6.76236 23.2988 6.76236 23.0637C6.76236 22.8285 6.95367 22.6389 7.19089 22.6389C7.42811 22.6389 7.61941 22.8285 7.61941 23.0637Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.94076 24.8389C7.68824 24.8389 7.48163 24.634 7.48163 24.3837C7.48163 24.1334 7.68824 23.9285 7.94076 23.9285C8.19329 23.9285 8.3999 24.1334 8.3999 24.3837C8.3999 24.634 8.19329 24.8389 7.94076 24.8389Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85937 25.1195C9.11954 25.1195 9.33381 25.3319 9.33381 25.5898C9.33381 25.8478 9.11954 26.0602 8.85937 26.0602C8.59919 26.0602 8.38493 25.8478 8.38493 25.5898C8.37727 25.3319 8.59154 25.1195 8.85937 25.1195Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.92293 26.2043C10.1908 26.2043 10.4127 26.4168 10.4127 26.6899C10.4127 26.9554 10.1984 27.1754 9.92293 27.1754C9.6551 27.1754 9.43318 26.9629 9.43318 26.6899C9.43318 26.4168 9.6551 26.2043 9.92293 26.2043Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1165 27.0767C11.4226 27.0767 11.6751 27.3271 11.6751 27.6305C11.6751 27.9339 11.4226 28.1843 11.1165 28.1843C10.8104 28.1843 10.5579 27.9339 10.5579 27.6305C10.5579 27.3271 10.8104 27.0767 11.1165 27.0767Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.425 27.8505C12.7387 27.8505 12.9989 28.1008 12.9989 28.4194C12.9989 28.7304 12.7464 28.9884 12.425 28.9884C12.1112 28.9884 11.851 28.738 11.851 28.4194C11.851 28.1008 12.1036 27.8505 12.425 27.8505Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8179 29.5952C13.5042 29.5952 13.244 29.3449 13.244 29.0263C13.244 28.7153 13.4965 28.4573 13.8179 28.4573C14.1317 28.4573 14.3918 28.7077 14.3918 29.0263C14.3918 29.3449 14.1393 29.5952 13.8179 29.5952Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2871 30.0429C14.9657 30.0429 14.6978 29.785 14.6978 29.4588C14.6978 29.1401 14.958 28.8746 15.2871 28.8746C15.6085 28.8746 15.8763 29.1326 15.8763 29.4588C15.8686 29.7774 15.6085 30.0429 15.2871 30.0429Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7947 30.2856C16.4733 30.2856 16.2055 30.0277 16.2055 29.7015C16.2055 29.3829 16.4657 29.1174 16.7947 29.1174C17.1161 29.1174 17.384 29.3753 17.384 29.7015C17.384 30.0201 17.1161 30.2856 16.7947 30.2856Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7513 29.7469C17.7513 29.4359 18.0038 29.178 18.3252 29.178C18.6389 29.178 18.8991 29.4283 18.8991 29.7469C18.8991 30.058 18.6466 30.3159 18.3252 30.3159C18.0038 30.3159 17.7513 30.0655 17.7513 29.7469Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.312 29.6029C19.312 29.3146 19.5492 29.0795 19.84 29.0795C20.1308 29.0795 20.368 29.3146 20.368 29.6029C20.368 29.8912 20.1308 30.1263 19.84 30.1263C19.5492 30.1263 19.312 29.8912 19.312 29.6029Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3324 29.747C21.0646 29.747 20.8503 29.5346 20.8503 29.2691C20.8503 29.0036 21.0646 28.7912 21.3324 28.7912C21.6002 28.7912 21.8145 29.0036 21.8145 29.2691C21.8145 29.5346 21.6002 29.747 21.3324 29.747Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.771 29.1781C22.5261 29.1781 22.3348 28.9809 22.3348 28.7457C22.3348 28.5029 22.5337 28.3133 22.771 28.3133C23.0158 28.3133 23.2071 28.5105 23.2071 28.7457C23.2071 28.9809 23.0158 29.1781 22.771 29.1781Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1255 28.3512C23.9572 28.3512 23.8118 28.2146 23.8118 28.0402C23.8118 27.8733 23.9495 27.7291 24.1255 27.7291C24.2939 27.7291 24.4393 27.8657 24.4393 28.0402C24.4393 28.2146 24.2939 28.3512 24.1255 28.3512Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3806 27.5167C25.1893 27.5167 25.0362 27.3649 25.0362 27.1753C25.0362 26.9856 25.1893 26.8339 25.3806 26.8339C25.5719 26.8339 25.725 26.9856 25.725 27.1753C25.725 27.3649 25.5719 27.5167 25.3806 27.5167Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5128 26.4243C26.3674 26.4243 26.245 26.303 26.245 26.1588C26.245 26.0147 26.3674 25.8933 26.5128 25.8933C26.6582 25.8933 26.7806 26.0147 26.7806 26.1588C26.7806 26.303 26.6582 26.4243 26.5128 26.4243Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5001 24.6947C27.6685 24.6947 27.8062 24.8313 27.8062 24.9981C27.8062 25.165 27.6685 25.3016 27.5001 25.3016C27.3318 25.3016 27.194 25.165 27.194 24.9981C27.194 24.8313 27.3318 24.6947 27.5001 24.6947Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8721 18.3452C29.6425 18.3452 29.4512 18.1556 29.4512 17.928C29.4512 17.7004 29.6425 17.5107 29.8721 17.5107C30.1017 17.5107 30.293 17.7004 30.293 17.928C30.293 18.1631 30.1017 18.3452 29.8721 18.3452Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7727 15.9632C30.0252 15.9632 30.2242 16.168 30.2242 16.4108C30.2242 16.6611 30.0176 16.8583 29.7727 16.8583C29.5202 16.8583 29.3212 16.6535 29.3212 16.4108C29.3212 16.168 29.5202 15.9632 29.7727 15.9632Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.4822 14.4612C29.7423 14.4612 29.9566 14.6736 29.9566 14.9315C29.9566 15.1894 29.7423 15.4018 29.4822 15.4018C29.222 15.4018 29.0077 15.1894 29.0077 14.9315C29.0077 14.6736 29.222 14.4612 29.4822 14.4612Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.4947 13.4901C28.4947 13.217 28.7166 12.997 28.9921 12.997C29.2676 12.997 29.4895 13.217 29.4895 13.4901C29.4895 13.7632 29.2676 13.9832 28.9921 13.9832C28.7243 13.9908 28.4947 13.7632 28.4947 13.4901Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.3341 12.6481C28.0433 12.6481 27.8061 12.4129 27.8061 12.1246C27.8061 11.8364 28.0433 11.6012 28.3341 11.6012C28.6249 11.6012 28.8621 11.8364 28.8621 12.1246C28.8621 12.4129 28.6249 12.6481 28.3341 12.6481Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9796 10.8577C26.9796 10.5695 27.2168 10.3343 27.5076 10.3343C27.7984 10.3343 28.0356 10.5695 28.0356 10.8577C28.0356 11.146 27.7984 11.3812 27.5076 11.3812C27.2091 11.3736 26.9796 11.146 26.9796 10.8577Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5131 10.2661C26.1993 10.2661 25.9468 10.0158 25.9468 9.70474C25.9468 9.39371 26.1993 9.14337 26.5131 9.14337C26.8268 9.14337 27.0793 9.39371 27.0793 9.70474C27.0793 10.0158 26.8268 10.2661 26.5131 10.2661Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.3341 23.3975C28.5177 23.3975 28.6708 23.5492 28.6708 23.7312C28.6708 23.9133 28.5177 24.065 28.3341 24.065C28.1504 24.065 27.9974 23.9133 27.9974 23.7312C27.9974 23.5492 28.1504 23.3975 28.3341 23.3975Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6939 22.3658C28.6939 22.1989 28.8316 22.0624 28.9999 22.0624C29.1683 22.0624 29.306 22.1989 29.306 22.3658C29.306 22.5327 29.1683 22.6693 28.9999 22.6693C28.8316 22.6693 28.6939 22.5327 28.6939 22.3658Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.1452 20.9321C29.1452 20.75 29.2983 20.5983 29.4819 20.5983C29.6656 20.5983 29.8186 20.75 29.8186 20.9321C29.8186 21.1141 29.6656 21.2658 29.4819 21.2658C29.2983 21.2583 29.1452 21.1141 29.1452 20.9321Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3672 19.4452C29.3672 19.2252 29.5508 19.0431 29.7727 19.0431C29.9946 19.0431 30.1783 19.2252 30.1783 19.4452C30.1783 19.6651 29.9946 19.8472 29.7727 19.8472C29.5508 19.8472 29.3672 19.6651 29.3672 19.4452Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5713 18.3528C31.334 18.3528 31.1427 18.1632 31.1427 17.928C31.1427 17.6928 31.334 17.5032 31.5713 17.5032C31.8085 17.5032 31.9998 17.6928 31.9998 17.928C32.0074 18.1632 31.8161 18.3528 31.5713 18.3528Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4868 16.8735C31.2343 16.8735 31.0276 16.6687 31.0276 16.4184C31.0276 16.168 31.2343 15.9632 31.4868 15.9632C31.7393 15.9632 31.9459 16.168 31.9459 16.4184C31.9459 16.6687 31.7393 16.8735 31.4868 16.8735Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2343 14.4308C31.5098 14.4308 31.7317 14.6508 31.7317 14.9239C31.7317 15.197 31.5098 15.417 31.2343 15.417C30.9589 15.417 30.7369 15.197 30.7369 14.9239C30.7369 14.6508 30.9589 14.4308 31.2343 14.4308Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2471 13.4674C30.2471 13.1563 30.4996 12.906 30.8134 12.906C31.1271 12.906 31.372 13.1563 31.372 13.4674C31.372 13.7784 31.1195 14.0287 30.8134 14.0287C30.4996 14.0212 30.2471 13.7708 30.2471 13.4674Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2243 12.6329C29.9106 12.6329 29.6504 12.3826 29.6504 12.0639C29.6504 11.7529 29.9029 11.495 30.2243 11.495C30.538 11.495 30.7982 11.7453 30.7982 12.0639C30.7982 12.375 30.538 12.6329 30.2243 12.6329Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.9158 10.7364C28.9158 10.4253 29.1683 10.1674 29.4897 10.1674C29.8035 10.1674 30.0636 10.4178 30.0636 10.7364C30.0636 11.0474 29.8111 11.3053 29.4897 11.3053C29.1683 11.3053 28.9158 11.0474 28.9158 10.7364Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0512 9.49987C28.0512 9.19643 28.2961 8.95367 28.6021 8.95367C28.9082 8.95367 29.1531 9.19643 29.1531 9.49987C29.1531 9.80331 28.9082 10.0461 28.6021 10.0461C28.2961 10.0461 28.0512 9.80331 28.0512 9.49987Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8578 5.21375C24.1562 5.21375 24.4011 5.4565 24.4011 5.75235C24.4011 6.04821 24.1562 6.29096 23.8578 6.29096C23.5594 6.29096 23.3145 6.04821 23.3145 5.75235C23.3145 5.4565 23.5594 5.21375 23.8578 5.21375Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.442 4.60693C22.7557 4.60693 23.0159 4.85727 23.0159 5.17589C23.0159 5.48691 22.7634 5.74484 22.442 5.74484C22.1283 5.74484 21.8681 5.4945 21.8681 5.17589C21.8757 4.85727 22.1283 4.60693 22.442 4.60693Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9725 4.24274C21.2557 4.24274 21.4852 4.47032 21.4852 4.751C21.4852 5.03168 21.2557 5.25926 20.9725 5.25926C20.6894 5.25926 20.4598 5.03168 20.4598 4.751C20.4675 4.47032 20.6894 4.24274 20.9725 4.24274Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8784 4.50065C19.8784 4.72823 19.6947 4.9103 19.4652 4.9103C19.2356 4.9103 19.0519 4.72823 19.0519 4.50065C19.0519 4.27307 19.2356 4.091 19.4652 4.091C19.6947 4.091 19.8784 4.27307 19.8784 4.50065Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3558 4.40965C18.3558 4.63723 18.1721 4.81929 17.9426 4.81929C17.713 4.81929 17.5293 4.63723 17.5293 4.40965C17.5293 4.18206 17.713 4 17.9426 4C18.1721 4 18.3558 4.18206 18.3558 4.40965Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.741 4.50067C16.741 4.68273 16.5956 4.82687 16.412 4.82687C16.2283 4.82687 16.0829 4.68273 16.0829 4.50067C16.0829 4.3186 16.2283 4.17447 16.412 4.17447C16.5956 4.16688 16.741 4.3186 16.741 4.50067Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1495 4.75104C15.1495 4.88 15.0424 4.9862 14.9123 4.9862C14.7822 4.9862 14.675 4.88 14.675 4.75104C14.675 4.62207 14.7822 4.51587 14.9123 4.51587C15.0424 4.51587 15.1495 4.62207 15.1495 4.75104Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4351 5.00134C13.527 5.00134 13.6035 5.0772 13.6035 5.16824C13.6035 5.25927 13.527 5.33513 13.4351 5.33513C13.3433 5.33513 13.2668 5.25927 13.2668 5.16824C13.2668 5.0772 13.3433 5.00134 13.4351 5.00134Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0272 5.55518C12.1343 5.55518 12.2262 5.64621 12.2262 5.75241C12.2262 5.85862 12.1343 5.94965 12.0272 5.94965C11.9201 5.94965 11.8282 5.85862 11.8282 5.75241C11.8282 5.64621 11.9124 5.55518 12.0272 5.55518Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5841 8.9385C27.2704 8.9385 27.0102 8.68816 27.0102 8.36955C27.0102 8.05852 27.2627 7.8006 27.5841 7.8006C27.8979 7.8006 28.158 8.05094 28.158 8.36955C28.1504 8.68816 27.8979 8.9385 27.5841 8.9385Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4439 7.95991C26.1149 7.95991 25.8471 7.6944 25.8471 7.3682C25.8471 7.042 26.1149 6.77649 26.4439 6.77649C26.773 6.77649 27.0408 7.042 27.0408 7.3682C27.0408 7.68681 26.773 7.95991 26.4439 7.95991Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6536 6.48819C24.6536 6.19234 24.8985 5.94958 25.1969 5.94958C25.4954 5.94958 25.7402 6.19234 25.7402 6.48819C25.7402 6.78405 25.4954 7.0268 25.1969 7.0268C24.8908 7.0268 24.6536 6.78405 24.6536 6.48819Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6881 6.31378C10.7799 6.31378 10.8564 6.38964 10.8564 6.48067C10.8564 6.57171 10.7799 6.64757 10.6881 6.64757C10.5963 6.64757 10.5197 6.57171 10.5197 6.48067C10.5197 6.38964 10.5963 6.31378 10.6881 6.31378Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.22655 7.3606C9.22655 7.24681 9.31838 7.14819 9.44082 7.14819C9.5556 7.14819 9.65508 7.23923 9.65508 7.3606C9.65508 7.47439 9.56325 7.57301 9.44082 7.57301C9.31838 7.57301 9.22655 7.47439 9.22655 7.3606Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.30046 8.1723C8.40759 8.1723 8.49942 8.26333 8.49942 8.36954C8.49942 8.47574 8.40759 8.56678 8.30046 8.56678C8.19333 8.56678 8.1015 8.47574 8.1015 8.36954C8.1015 8.26333 8.19333 8.1723 8.30046 8.1723Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.28299 9.74265C7.14525 9.74265 7.03812 9.63644 7.03812 9.49989C7.03812 9.36335 7.14525 9.25714 7.28299 9.25714C7.42073 9.25714 7.52786 9.36335 7.52786 9.49989C7.52786 9.63644 7.41308 9.74265 7.28299 9.74265Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.39501 10.4861C6.53275 10.4861 6.64754 10.5999 6.64754 10.7364C6.64754 10.873 6.53275 10.9868 6.39501 10.9868C6.25727 10.9868 6.14249 10.873 6.14249 10.7364C6.14249 10.5999 6.25727 10.4861 6.39501 10.4861Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.65295 11.8137C5.79069 11.8137 5.90548 11.9275 5.90548 12.064C5.90548 12.2005 5.79069 12.3143 5.65295 12.3143C5.51521 12.3143 5.40043 12.2005 5.40043 12.064C5.40043 11.9275 5.51521 11.8137 5.65295 11.8137Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.07117 13.7329C4.92577 13.7329 4.80334 13.6115 4.80334 13.4674C4.80334 13.3232 4.92577 13.2018 5.07117 13.2018C5.21656 13.2018 5.339 13.3232 5.339 13.4674C5.339 13.6115 5.21656 13.7329 5.07117 13.7329Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.65062 14.6508C4.80366 14.6508 4.9261 14.7722 4.9261 14.9239C4.9261 15.0756 4.80366 15.197 4.65062 15.197C4.49757 15.197 4.37514 15.0756 4.37514 14.9239C4.37514 14.7722 4.49757 14.6508 4.65062 14.6508Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.68879 16.4183C4.68879 16.5776 4.5587 16.7141 4.39035 16.7141C4.22965 16.7141 4.09191 16.5852 4.09191 16.4183C4.09191 16.259 4.222 16.1224 4.39035 16.1224C4.5587 16.1224 4.68879 16.2514 4.68879 16.4183Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 17.928C4 17.7611 4.13774 17.6245 4.30609 17.6245C4.47444 17.6245 4.61218 17.7611 4.61218 17.928C4.61218 18.0948 4.47444 18.2314 4.30609 18.2314C4.13774 18.2314 4 18.0948 4 17.928Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.71938 19.4452C4.71938 19.6273 4.57399 19.7714 4.39033 19.7714C4.20668 19.7714 4.06129 19.6273 4.06129 19.4452C4.06129 19.2707 4.20668 19.119 4.39033 19.119C4.57399 19.119 4.71938 19.2632 4.71938 19.4452Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.65057 21.2734C4.45926 21.2734 4.31387 21.1217 4.31387 20.9396C4.31387 20.75 4.46691 20.6058 4.65057 20.6058C4.84187 20.6058 4.98726 20.7576 4.98726 20.9396C4.98726 21.1217 4.83422 21.2734 4.65057 21.2734Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.46915 22.3961C5.46915 22.6161 5.29315 22.7906 5.07123 22.7906C4.84932 22.7906 4.67332 22.6161 4.67332 22.3961C4.67332 22.1761 4.84932 22.0016 5.07123 22.0016C5.29315 22.0016 5.46915 22.1761 5.46915 22.3961Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.65299 23.3975C5.87491 23.3975 6.05091 23.5719 6.05091 23.7919C6.05091 24.0119 5.87491 24.1864 5.65299 24.1864C5.43108 24.1864 5.25507 24.0119 5.25507 23.7919C5.26273 23.5795 5.43873 23.3975 5.65299 23.3975Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.83885 25.1195C6.83885 25.3623 6.63989 25.5519 6.40267 25.5519C6.1578 25.5519 5.96649 25.3547 5.96649 25.1195C5.96649 24.8768 6.16545 24.6871 6.40267 24.6871C6.63989 24.6871 6.83885 24.8768 6.83885 25.1195Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.28274 25.8705C7.55057 25.8705 7.77249 26.0905 7.77249 26.356C7.77249 26.6215 7.55057 26.8415 7.28274 26.8415C7.01492 26.8415 6.793 26.6215 6.793 26.356C6.793 26.0905 7.00726 25.8705 7.28274 25.8705Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.30056 27.0008C8.56839 27.0008 8.7903 27.2208 8.7903 27.4863C8.7903 27.7518 8.56839 27.9718 8.30056 27.9718C8.03273 27.9718 7.81081 27.7518 7.81081 27.4863C7.81081 27.2208 8.02508 27.0008 8.30056 27.0008Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.44069 27.9567C9.73913 27.9567 9.984 28.1994 9.984 28.4953C9.984 28.7911 9.73913 29.0339 9.44069 29.0339C9.14225 29.0339 8.89738 28.7911 8.89738 28.4953C8.89738 28.1994 9.14225 27.9567 9.44069 27.9567Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2622 29.3752C11.2622 29.6863 11.0097 29.9442 10.6883 29.9442C10.3745 29.9442 10.1143 29.6938 10.1143 29.3752C10.1143 29.0566 10.3745 28.8063 10.6883 28.8063C11.002 28.8063 11.2622 29.0642 11.2622 29.3752Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6013 30.1036C12.6013 30.4222 12.3411 30.6725 12.0274 30.6725C11.706 30.6725 11.4535 30.4146 11.4535 30.1036C11.4535 29.7849 11.7137 29.5346 12.0274 29.5346C12.3411 29.5346 12.6013 29.7925 12.6013 30.1036Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4353 31.2567C13.1139 31.2567 12.8614 30.9988 12.8614 30.6877C12.8614 30.3691 13.1215 30.1188 13.4353 30.1188C13.7567 30.1188 14.0092 30.3767 14.0092 30.6877C14.0169 31.0063 13.7567 31.2567 13.4353 31.2567Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9046 31.6965C14.5756 31.6965 14.3078 31.431 14.3078 31.1048C14.3078 30.7786 14.5756 30.5131 14.9046 30.5131C15.2337 30.5131 15.5015 30.7786 15.5015 31.1048C15.5015 31.431 15.2337 31.6965 14.9046 31.6965Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8304 31.3629C15.8304 31.0442 16.0905 30.7863 16.4119 30.7863C16.7333 30.7863 16.9935 31.0442 16.9935 31.3629C16.9935 31.6815 16.7333 31.9394 16.4119 31.9394C16.0905 31.9394 15.8304 31.6815 15.8304 31.3629Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9424 32C17.6287 32 17.3761 31.7496 17.3761 31.4386C17.3761 31.1276 17.6287 30.8848 17.9424 30.8848C18.2561 30.8848 18.5087 31.1352 18.5087 31.4386C18.501 31.7496 18.2485 32 17.9424 32Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4652 31.8635C19.1821 31.8635 18.9525 31.6359 18.9525 31.3552C18.9525 31.0746 19.1821 30.847 19.4652 30.847C19.7484 30.847 19.9779 31.0746 19.9779 31.3552C19.9779 31.6435 19.7484 31.8635 19.4652 31.8635Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9728 31.5449C20.7279 31.5449 20.529 31.3477 20.529 31.1049C20.529 30.8622 20.7279 30.6649 20.9728 30.6649C21.2177 30.6649 21.4166 30.8622 21.4166 31.1049C21.4166 31.3477 21.2177 31.5449 20.9728 31.5449Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0669 30.6876C22.0669 30.4828 22.2352 30.3159 22.4418 30.3159C22.6484 30.3159 22.8168 30.4828 22.8168 30.6876C22.8168 30.8925 22.6484 31.0593 22.4418 31.0593C22.2352 31.0593 22.0669 30.8925 22.0669 30.6876Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5514 30.1035C23.5514 29.9366 23.6891 29.8077 23.8498 29.8077C24.0182 29.8077 24.1559 29.9442 24.1559 30.1035C24.1559 30.2704 24.0182 30.407 23.8498 30.407C23.6891 30.407 23.5514 30.2704 23.5514 30.1035Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.1968 29.6712C25.0284 29.6712 24.8984 29.5346 24.8984 29.3753C24.8984 29.2084 25.0361 29.0719 25.1968 29.0719C25.3651 29.0719 25.5029 29.2084 25.5029 29.3753C25.4952 29.5422 25.3651 29.6712 25.1968 29.6712Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4441 28.7608C26.2987 28.7608 26.1762 28.6394 26.1762 28.4952C26.1762 28.3511 26.291 28.2297 26.4441 28.2297C26.5895 28.2297 26.7119 28.3511 26.7119 28.4952C26.7119 28.6394 26.5895 28.7608 26.4441 28.7608Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5843 27.7139C27.4542 27.7139 27.3547 27.6077 27.3547 27.4864C27.3547 27.3574 27.4542 27.2588 27.5843 27.2588C27.7144 27.2588 27.8139 27.365 27.8139 27.4864C27.8139 27.6153 27.7067 27.7139 27.5843 27.7139Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6021 26.0829C28.7551 26.0829 28.8775 26.2043 28.8775 26.356C28.8775 26.5078 28.7551 26.6291 28.6021 26.6291C28.449 26.6291 28.3266 26.5078 28.3266 26.356C28.3266 26.2043 28.449 26.0829 28.6021 26.0829Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7653 25.1195C29.7653 25.2712 29.6429 25.3926 29.4898 25.3926C29.3368 25.3926 29.2144 25.2712 29.2144 25.1195C29.2144 24.9678 29.3368 24.8464 29.4898 24.8464C29.6429 24.8464 29.7653 24.9678 29.7653 25.1195Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.9183 23.7919C29.9183 23.625 30.056 23.4885 30.2244 23.4885C30.3927 23.4885 30.5305 23.625 30.5305 23.7919C30.5305 23.9588 30.3927 24.0953 30.2244 24.0953C30.056 24.0953 29.9183 23.9588 29.9183 23.7919Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4922 22.3961C30.4922 22.2216 30.6376 22.0775 30.8136 22.0775C30.9896 22.0775 31.135 22.2216 31.135 22.3961C31.135 22.5705 30.9896 22.7147 30.8136 22.7147C30.6299 22.7147 30.4922 22.5705 30.4922 22.3961Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2344 21.3264C31.0202 21.3264 30.8442 21.152 30.8442 20.9396C30.8442 20.7272 31.0202 20.5527 31.2344 20.5527C31.4487 20.5527 31.6247 20.7272 31.6247 20.9396C31.6247 21.152 31.4487 21.3264 31.2344 21.3264Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.487 19.8624C31.2574 19.8624 31.0661 19.6728 31.0661 19.4452C31.0661 19.2176 31.2574 19.028 31.487 19.028C31.7166 19.028 31.9079 19.2176 31.9079 19.4452C31.9079 19.6728 31.7242 19.8624 31.487 19.8624Z",
			fill: "#FFFFFF"
		})
	]
});
export default SvgLogoIcon;
